import api from "./axios";

export async function getAnnouncements() {
    try {
        const response = await api.get("/announcement");
        return response.data;
    } catch (error) {
        console.error("Error fetching announcements:", error);
    }
}

export async function sendLexMessage(message) {
    try {
        const response = await api.post("/chat/message", { text: message });
        return response.data;
    } catch (error) {
        console.error("Error sending lex message:", error);
    }
}

export async function sendContactFormMessage(contactFormInfo) {
    try {
        const response = await api.post("/contact", contactFormInfo);
        return response;
    } catch (error) {
        console.error("Error sending lex message:", error);
    }
}
